import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditHomepage extends Component {

    state = {
        homepage: this.props.homepage,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { homepage = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditHomepage"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Homepage">
            <Form>
                <div>
                    <input
                        type="url"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Homepage URL"
                        value={homepage}
                        onChange={e => this.setState({ homepage: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditHomepage



// WEBPACK FOOTER //
// ./src/components/LBUs/EditHomepage.js